import classNames from 'classnames';
import { Html5Qrcode, Html5QrcodeScannerState } from 'html5-qrcode';
import * as PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';
import { t } from '../../lang';
import TelegramWebApiService from '../../services/TelegramWebApiService';
import Button from '../Button';
import Icon, { Icons } from '../Icon/Icon';
import './QrScanner.scss';

const defaultIconSize = 24;
const scanDefaultIcon = (
	<Icon type={Icons.VIEWFINDER_QRCODE_SCAN} className='Button__icon' width={defaultIconSize} height={defaultIconSize} />
);
const QrScanner = ({ updateValue, className, element = scanDefaultIcon }) => {
	const [isCameraAvailable, setIsCameraAvailable] = useState(false);
	const [isScanning, setIsScanning] = useState(false);

	const isItTelegram = useSelector(state => state.app.isItTelegram);

	const scannerRef = useRef(null);

	const onScan = result => {
		updateValue(result);
		return true;
	};

	const startTgScanner = () => {
		TelegramWebApiService.TelegramWebApi.showScanQrPopup({}, onScan);
	};

	const startWebScanner = async () => {
		setIsScanning(true);
		// };
		// const startWebScanner1 = async () => {
		// 	setIsScanning(true);

		const scanner = new Html5Qrcode('QrScanner__modal-reader');
		scannerRef.current = scanner;

		await scanner.start({ facingMode: 'environment' }, { fps: 10, qrbox: { width: 240, height: 240 } }, decodedText => {
			console.log('decodedText', decodedText);
			updateValue(decodedText);
			scanner?.stop();
			setIsScanning(false);
			scannerRef.current = null;
		});
	};

	const startScan = e => {
		e.preventDefault();
		e.stopPropagation();

		if (isItTelegram) {
			startTgScanner();
		} else {
			startWebScanner();
		}
	};

	const checkCameraPermission = async () => {
		try {
			const permission = await navigator.permissions.query({ name: 'camera' });
			console.log('permission', permission);
			console.log('permission.state', permission.state);
			if (permission.state === 'granted') {
				setIsCameraAvailable(true);
			} else {
				const stream = await navigator.mediaDevices.getUserMedia({ video: true });
				stream.getTracks().forEach(track => track.stop());
				setIsCameraAvailable(true);
			}
		} catch (error) {
			console.log('Camera access error', error);
		}
	};

	useEffect(() => {
		checkCameraPermission();

		return () => {
			if (scannerRef.current) {
				const state = scannerRef.current?.getState();

				if (state === Html5QrcodeScannerState.SCANNING || state === Html5QrcodeScannerState.PAUSED) {
					scannerRef.current?.stop().catch(console.error);
				}

				scannerRef.current = null;
				setIsScanning(false);
			}
		};
	}, []);

	if (!isCameraAvailable) return null;

	return (
		<div className={classNames('QrScanner', className)}>
			<div className='QrScanner__element' onClick={startScan}>
				{element}
			</div>

			{createPortal(
				<div className={classNames('QrScanner__modal', { openQrScan: isScanning && !isItTelegram })}>
					<div id='QrScanner__modal-reader'>
						<div className='video1'></div>
					</div>

					<div className='QrScanner__modal-content'>
						<div className='QrScanner__modal-title'>{t('Scan the QR code')}</div>
						<div className='QrScanner__modal-subtitle'>{t('Point your camera at the QR code with the address.')}</div>

						<div className='video'></div>

						<Button
							styleType='tertiary'
							onClick={() => {
								setIsScanning(false);
								scannerRef.current && scannerRef.current.stop().catch(console.error);
							}}
						>
							{t('Cancel')}
						</Button>
					</div>
				</div>,
				document.body
			)}
		</div>
	);
};

QrScanner.propTypes = {
	className: PropTypes.string,
	updateValue: PropTypes.func,
	element: PropTypes.node,
	// element: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default QrScanner;
